import Vue from 'vue'
import VueRouter from 'vue-router'

import Main from '@/components/Main.vue'
import Thanks from '@/components/Thanks.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', component: Main },
  { path: '/thanks', component: Thanks }
]

export default new VueRouter({ mode: 'history', routes })
